import { styled } from 'styled-components'
import { onMediumScreen } from 'mixtiles-web-common'

export const Container = styled.div`
  padding: 48px 20px 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${onMediumScreen()} {
    padding-top: 0;
    margin-right: 12px;
  }
`

export const ContentContainer = styled.div`
  padding-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 46px;
  ${onMediumScreen()} {
    flex-direction: row;
    padding-bottom: 0;
    gap: 183px;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Title = styled.h2`
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  ${onMediumScreen()} {
    display: none;
  }
`

export const Separator = styled.div`
  background: ${({ theme }) => theme.colors.grayMedium};
  height: 1px;
  width: 100%;
  ${onMediumScreen()} {
    display: none;
  }
`

export const IllustrationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  text-align: center;
  text-transform: capitalize;

  ${onMediumScreen()} {
    gap: 52px;
  }
`

export const IllustrationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  color: ${({ theme }) => theme.colors.secondaryDark};
  font-size: 18px;
  font-weight: 500;
  ${onMediumScreen()} {
    justify-content: space-between;
    font-size: 17px;
    line-height: 30.414px; /* 178.904% */
    gap: 15px;
    font-weight: 400;
  }
`

export const SupportImage = styled.img<{ $isDarkVariant?: boolean }>`
  width: 98px;
  height: ${({ $isDarkVariant }) => ($isDarkVariant ? 'auto' : '78px')};
  ${onMediumScreen()} {
    width: 102px;
    height: 80px;
  }
`

export const ShippingImage = styled.img<{ $isDarkVariant?: boolean }>`
  width: 110px;
  height: ${({ $isDarkVariant }) => ($isDarkVariant ? 'auto' : '89px')};
  ${onMediumScreen()} {
    width: 110px;
    height: 86px;
  }
`

export const RatedImage = styled.img`
  width: 100px;
  height: 100px;
  ${onMediumScreen()} {
    width: 96px;
    height: 96px;
  }
`
